import { memo } from 'react'

const CarouselButtonIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="40"
    viewBox="0 0 13 40"
    fill="none"
  >
    <path
      d="M2 37.7052L10.2231 22.5574C11.0208 21.0879 11.0312 19.3169 10.2507 17.8382L2 2.2052"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

export { CarouselButtonIcon }
